

























import PeriodBtn from '@/components/common/datepicker/PeriodBtn.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import DatePicker from 'tui-date-picker';
import {getToday, addDay, addMonth, getStrDate, changeDateFormat} from '@/utils/dateUtils';
import { CalendarInfo, Optional, PeriodType } from '@/types';

const today = getToday();

@Component({
  components: {PeriodBtn, CompSelectBox}
})
export default class PeriodDateCalendar extends Vue {
  // Info
  @Prop() private option?: Optional<CalendarInfo>;
  @Prop() private btnDisabled?: boolean;
  @Prop() private startDisabled?: boolean;
  @Prop() private endDisabled?: boolean;
  // private initCalendarOver = false; // DOM을 동적으로 로드하게 만들어서 혼란을 초래
  private calendarInfo: CalendarInfo = {
    dateType: 'Ymd',
    name: 'period',
    havePeriodBtn: true,
    period: '3m',
    periodTypes: ['td', '1w', '1m', '3m', '6m', '1y'],
    endPeriod: false,
    fromRanges: '1900-1-1',
    toRanges: '2999-12-31',
    buttonStyles: {}
  };

  // StartYmdt
  @Prop() private startYmdt: string;
  private pickerStart: string = '';
  private selecdStartHms: string = '00:00:00';
  private startDatepicker: any;
  private get startList(): string[] {
    let starts = [];
    for (let i = 0; i < 24; i++) {
      let tempH = i < 10 ? '0' + i : i.toString();
      starts.push({
        value: tempH + ':00:00',
        name: tempH + ':00'
      });
    }
    return starts;
  }
  get buttonStyles(): string {
    if (!this.calendarInfo.buttonStyles) {
      return '';
    }

    return Object.entries(this.calendarInfo.buttonStyles)
      .map(([property, value]) => `${property}: ${value}`)
      .join(';');
  }
  @Watch('startYmdt', {immediate: false, deep: false})
  onStartChanged(next: string) {
    if (next === '' || next === null || next === undefined) {
      this.pickerStart = '';
      this.isPeriodChange = true;
      this.startDatepicker.setDate(new Date(''));
      this.isPeriodChange = false;
      this.selecdStartHms = '00:00:00';
    } else {
      let nextDate = new Date(next);
      if (nextDate instanceof Date && !isNaN(nextDate.getTime())) {
        let tempYmd = changeDateFormat(next, 'YYYY-MM-DD');
        let temptime = changeDateFormat(next, 'HH:mm:ss');
        this.pickerStart = tempYmd;
        this.isPeriodChange = true;
        if (this.startDatepicker) {
          this.startDatepicker.setDate(new Date(tempYmd));
        }
        this.isPeriodChange = false;
        this.selecdStartHms = temptime;
      }
    }
  }
  @Watch('pickerStart', {immediate: false, deep: false})
  onPickerStartChanged(next: string) {
    this.changeYmdt('start', next, this.selecdStartHms);
  }
  @Watch('selecdStartHms', {immediate: false, deep: false})
  onSelecdStartHmsChanged(next: string) {
    let tempStart = this.startDatepicker._date;
    let tempEnd = this.endDatepicker._date;
    if (tempStart && tempEnd && getStrDate(tempStart) === getStrDate(tempEnd) && this.selecdStartHms > this.selecdEndHms) {
      alert(this.$t('COMMON_DATE_SPAN_ERR'));
      this.$nextTick(() => {
        this.selecdStartHms = changeDateFormat(this.startYmdt, 'HH:mm:ss');
      });
    } else {
      this.changeYmdt('start', this.pickerStart, next);
    }
  }

  // EndYmdt
  @Prop() private endYmdt: string;
  private pickerEnd: string = '';
  private selecdEndHms: string = '23:59:59';
  private endDatepicker: any;
  private get endList(): string[] {
    let ends = [];
    for (let i = 0; i < 24; i++) {
      let tempH = i < 10 ? '0' + i : i.toString();
      ends.push({
        value: tempH + ':59:59',
        name: tempH + ':59'
      });
    }
    return ends;
  }
  @Watch('endYmdt', {immediate: false, deep: false})
  onEndChanged(next: string) {
    if (next === '' || next === null || next === undefined) {
      this.pickerEnd = '';
      this.isPeriodChange = true;
      this.endDatepicker.setDate(new Date(''));
      this.isPeriodChange = false;
      this.selecdEndHms = '23:59:59';
    } else {
      let nextDate = new Date(next);
      if (nextDate instanceof Date && !isNaN(nextDate.getTime())) {
        let tempYmd = changeDateFormat(next, 'YYYY-MM-DD');
        let temptime = changeDateFormat(next, 'HH:mm:ss');
        this.pickerEnd = tempYmd;
        this.isPeriodChange = true;
        if (this.endDatepicker) {
          this.endDatepicker.setDate(new Date(tempYmd));
        }
        this.isPeriodChange = false;
        this.selecdEndHms = temptime;
      }
    }
  }
  @Watch('pickerEnd', {immediate: false, deep: false})
  onPickerEndChanged(next: string) {
    this.changeYmdt('end', next, this.selecdEndHms);
  }
  @Watch('selecdEndHms', {immediate: false, deep: false})
  onSelecdEndHmsChanged(next: string) {
    let tempStart = this.startDatepicker._date;
    let tempEnd = this.endDatepicker._date;
    if (tempStart && tempEnd && getStrDate(tempStart) === getStrDate(tempEnd) && this.selecdStartHms > this.selecdEndHms) {
      alert(this.$t('COMMON_DATE_SPAN_ERR'));
      this.$nextTick(() => {
        this.selecdEndHms = changeDateFormat(this.endYmdt, 'HH:mm:ss');
      });
    } else {
      let changeed = true;
      if (typeof this.calendarInfo.checkDate === 'function') {
        changeed = this.calendarInfo.checkDate(this.pickerEnd + ' ' + next);
      }
      if (changeed) {
        this.changeYmdt('end', this.pickerEnd, next);
      } else {
        this.$nextTick(() => {
          this.selecdEndHms = changeDateFormat(this.endYmdt, 'HH:mm:ss');
        });
      }
    }
  }

  // change
  changeYmdt(type: string, ymd: string, hms: string) {
    let ymdt = '';
    if (this.calendarInfo.dateType === 'YmdH' || this.calendarInfo.dateType === 'YmdHm') {
      ymdt = ymd + ' ' + hms;
    } else {
      ymdt = ymd;
    }
    if (type === 'start') {
      this.$emit('update:startYmdt', ymdt);
    } else if (type === 'end') {
      this.$emit('update:endYmdt', ymdt);
    }
  }

  private isPeriodChange = false;
  public clickPeriod(periodType: PeriodType) {
    if (!this.calendarInfo.havePeriodBtn) return '';
    
    if (this.calendarInfo.endPeriod) {
      this.pickerStart = getToday();
    } else {
      this.pickerEnd = getToday();
    }
    return this.changePeriod(periodType);
  }
  
  private handlePeriodChange(periodType: PeriodType) {
    // 퀵버튼으로 기간 선택 시 종료일은 항상 오늘로 세팅
    this.pickerEnd = today;
    this.changePeriod(periodType);
  }
  
  private changePeriod(periodType: PeriodType) {
    const tempPeriod = {
      ...this.getPeriod(periodType)
    };

    this.pickerStart = tempPeriod.start;
    this.isPeriodChange = true;
    this.startDatepicker.setDate(new Date(tempPeriod.start));

    this.pickerEnd = tempPeriod.end;
    this.isPeriodChange = true;
    this.endDatepicker.setDate(new Date(tempPeriod.end));
    this.isPeriodChange = false;
    return tempPeriod;
  }
  public getPeriod(periodType: PeriodType) {
    this.calendarInfo.period = periodType;

    let oldStart = this.pickerStart || getToday();
    let oldEnd = this.pickerEnd || getToday();

    let res = {
      start: '',
      end: ''
    };
    switch (periodType) {
      case 'all':
        res.start = '';
        res.end = '';
        break;
      case 'td':
        res.start = getToday();
        res.end = getToday();
        break;
      case 'ytd':
        res.start = addDay(new Date(), -1);
        res.end = addDay(new Date(), -1);
        break;
      case '3d':
        res.start = this.calendarInfo.endPeriod ? oldStart : addDay(new Date(oldEnd), -3);
        res.end = this.calendarInfo.endPeriod ? addDay(new Date(oldStart), 3) : oldEnd;
        break;
      case '6d':
      case '6d1w':
        res.start = this.calendarInfo.endPeriod ? oldStart : addDay(new Date(oldEnd), -6);
        res.end = this.calendarInfo.endPeriod ? addDay(new Date(oldStart), 6) : oldEnd;
        break;
      case '7d':
      case '1w':
        res.start = this.calendarInfo.endPeriod ? oldStart : addDay(new Date(oldEnd), -7);
        res.end = this.calendarInfo.endPeriod ? addDay(new Date(oldStart), 7) : oldEnd;
        break;
      case '30d':
        res.start = this.calendarInfo.endPeriod ? oldStart : addDay(new Date(oldEnd), -30);
        res.end = this.calendarInfo.endPeriod ? addDay(new Date(oldStart), 30) : oldEnd;
        break;
      case '1m':
        res.start = this.calendarInfo.endPeriod ? oldStart : addMonth(new Date(oldEnd), -1);
        res.end = this.calendarInfo.endPeriod ? addMonth(new Date(oldStart), 1) : oldEnd;
        break;
      case '1m29d':
        res.start = this.calendarInfo.endPeriod ? oldStart : addDay(new Date(oldEnd), -29);
        res.end = this.calendarInfo.endPeriod ? addDay(new Date(oldStart), 29) : oldEnd;
        break;
      case '60d':
        res.start = this.calendarInfo.endPeriod ? oldStart : addDay(new Date(oldEnd), -60);
        res.end = this.calendarInfo.endPeriod ? addDay(new Date(oldStart), 60) : oldEnd;
        break;
      case '2m':
        res.start = this.calendarInfo.endPeriod ? oldStart : addMonth(new Date(oldEnd), -2);
        res.end = this.calendarInfo.endPeriod ? addMonth(new Date(oldStart), 2) : oldEnd;
        break;
      case '90d':
        res.start = this.calendarInfo.endPeriod ? oldStart : addDay(new Date(oldEnd), -90);
        res.end = this.calendarInfo.endPeriod ? addDay(new Date(oldStart), 90) : oldEnd;
        break;
      case '3m':
        res.start = this.calendarInfo.endPeriod ? oldStart : addMonth(new Date(oldEnd), -3);
        res.end = this.calendarInfo.endPeriod ? addMonth(new Date(oldStart), 3) : oldEnd;
        break;
      case '6m':
        res.start = this.calendarInfo.endPeriod ? oldStart : addMonth(new Date(oldEnd), -6);
        res.end = this.calendarInfo.endPeriod ? addMonth(new Date(oldStart), 6) : oldEnd;
        break;
      case '1y':
        res.start = this.calendarInfo.endPeriod ? oldStart : addMonth(new Date(oldEnd), -12);
        res.end = this.calendarInfo.endPeriod ? addMonth(new Date(oldStart), 12) : oldEnd;
        break;
    }

    return res;
  }
  private checkSpan(): boolean {
    let res = true;
    let tempStart = this.startDatepicker._date;
    let tempEnd = this.endDatepicker._date;
    if (tempStart && tempEnd && getStrDate(tempStart) > getStrDate(tempEnd) && !this.isPeriodChange) {
      alert(this.$t('COMMON_DATE_SPAN_ERR'));
      res = false;
    }
    this.isPeriodChange = false;
    return res;
  }

  private onClickToday(e: any) {
    const targetWrap = $(e.target).parents('.date-picker_wrap');
    const targetPickerId = targetWrap.find('input.date-picker').attr('id');
    if (targetPickerId === `startYmd_${this.calendarInfo.name}`) {
      if (getToday() > this.pickerEnd) {
        alert(this.$t('COMMON_DATE_SPAN_ERR'));
      } else {
        this.pickerStart = getToday();
        this.startDatepicker.setDate(new Date());
      }
    }
    if (targetPickerId === `endYmd_${this.calendarInfo.name}`) {
      if (this.pickerStart > getToday()) {
        alert(this.$t('COMMON_DATE_SPAN_ERR'));
      } else {
        let changeed = true;
        if (typeof this.calendarInfo.checkDate === 'function') {
          changeed = this.calendarInfo.checkDate(getToday() + ' ' + this.selecdEndHms);
        }
        if (changeed) {
          this.pickerEnd = getToday();
          this.endDatepicker.setDate(new Date());
        }
      }
    }
  }

  private editOption(options: any) {
    Object.assign(this.calendarInfo, options);
  }

  private initOption() {
    if (this.option) {
      this.calendarInfo = Object.assign({}, this.calendarInfo, this.option);
    }
    // this.initCalendarOver = true;
  }

  private editPeriodFlg = true;
  private initStartPicker() {
    if (this.startYmdt === '' || this.startYmdt === null || this.startYmdt === undefined) {
      this.pickerStart = '';
    } else {
      this.pickerStart = changeDateFormat(this.startYmdt, 'YYYY-MM-DD');
      this.selecdStartHms = changeDateFormat(this.startYmdt, 'HH:mm:ss');
    }
    const container = this.$refs.containerStartDate as HTMLElement;
    const inputStart = this.$refs.inputStartDate as HTMLElement;

    this.startDatepicker = new DatePicker(container, {
      language: 'ko',
      date: new Date(this.pickerStart),
      input: {
        element: inputStart,
        format: 'yyyy-MM-dd'
      },
      selectableRanges: [[new Date(this.calendarInfo.fromRanges), new Date(this.calendarInfo.toRanges)]]
    });
    this.startDatepicker.on('change', (): void => {
      if (this.checkSpan()) {
        this.pickerStart = getStrDate(this.startDatepicker._date);
        if (this.startDatepicker.isOpened() && this.editPeriodFlg) {
          this.calendarInfo.period = '';
        }
        this.editPeriodFlg = true;
      } else {
        this.editPeriodFlg = false;
        this.startDatepicker.setDate(new Date(this.pickerStart));
      }
    });
    this.startDatepicker.on('open', (): void => {
      if (typeof this.calendarInfo.onStartOpen === 'function') {
        this.calendarInfo.onStartOpen();
      }
      $('#pop').show();
    });
    this.startDatepicker.on('close', (): void => {
      if (typeof this.calendarInfo.onStartClose === 'function') {
        this.calendarInfo.onStartClose();
      }
      $('#pop').hide();
    });
  }
  private initEndPicker() {
    if (this.endYmdt === '' || this.endYmdt === null || this.endYmdt === undefined) {
      this.pickerEnd = '';
    } else {
      this.pickerEnd = changeDateFormat(this.endYmdt, 'YYYY-MM-DD');
      this.selecdEndHms = changeDateFormat(this.endYmdt, 'HH:mm:ss').replace(/00:00:00/, '23:59:59');
    }
    const container = this.$refs.containerEndDate as HTMLElement;
    const inputEnd = this.$refs.inputEndDate as HTMLElement;

    this.endDatepicker = new DatePicker(container, {
      language: 'ko',
      date: new Date(this.pickerEnd),
      input: {
        element: inputEnd,
        format: 'yyyy-MM-dd'
      },
      selectableRanges: [[new Date(this.calendarInfo.fromRanges), new Date(this.calendarInfo.toRanges)]]
    });
    this.endDatepicker.on('change', (): void => {
      if (this.checkSpan()) {
        let changeed = true;
        if (typeof this.calendarInfo.checkDate === 'function') {
          changeed = this.calendarInfo.checkDate(getStrDate(this.endDatepicker._date) + ' ' + this.selecdEndHms);
        }
        if (changeed) {
          this.pickerEnd = getStrDate(this.endDatepicker._date);
          if (this.endDatepicker.isOpened() && this.editPeriodFlg) {
            this.calendarInfo.period = '';
          }
          this.editPeriodFlg = true;
        } else {
          this.editPeriodFlg = false;
          this.endDatepicker.setDate(new Date(this.pickerEnd));
        }
      } else {
        this.editPeriodFlg = false;
        this.endDatepicker.setDate(new Date(this.pickerEnd));
      }
    });
    this.endDatepicker.on('open', (): void => {
      if (typeof this.calendarInfo.onEndOpen === 'function') {
        this.calendarInfo.onEndOpen();
      }
      $('#pop').show();
    });
    this.endDatepicker.on('close', (): void => {
      if (typeof this.calendarInfo.onEndClose === 'function') {
        this.calendarInfo.onEndClose();
      }
      $('#pop').hide();
    });
  }
	
	public initialize(periodButtonType?: PeriodType) {
    this.initOption();
    this.initStartPicker();
    this.initEndPicker();
    this.clickPeriod(periodButtonType);
  }
  
  private originPeriodType: PeriodType = '3m';
  private created() {
    this.originPeriodType = this.option?.period ?? this.originPeriodType;
  }

  private mounted() {
    $('#wrap').on('click', '.tui-calendar-title-today', $.proxy(this.onClickToday, this));
	  this.initialize(this.originPeriodType);
  }
}
